import { Link } from "react-router-dom";
import type { NavChildren, NavigationA } from "@components/Header/types";
import { useGetMainNavList } from "@hooks/useGetMainNavList";
import cx from "classnames";

import { navigationConstant } from "./constant";

export type NavigationProps = {
  data?: NavigationA;
  position?: string;
};

export function Navigation({
  data,
  position,
}: NavigationProps): React.ReactElement {
  const navigationData = data?.length ? data : navigationConstant;
  const findMenuData = useGetMainNavList({ navigationData, position });

  return (
    <nav aria-label={`header-nav-${position}`}>
      <ul
        className={cx(
          "flex max-h-[37px] overflow-hidden",
          position && position === "left"
            ? "flex-wrap "
            : "flex-wrap-reverse content-end justify-end"
        )}
      >
        {findMenuData?.map((item) => {
          return <NavItem item={item} key={item.key} position={position} />;
        })}
      </ul>
    </nav>
  );
}

type NavItemProps = {
  item: NavChildren;
  position?: string;
};

const navItemStyle = cx("p-3 duration-300", "hover:bg-gray-250 rounded-[25px]");

function NavItem({ item, position }: NavItemProps): React.ReactElement {
  const { label, link }: NavChildren = item;
  return (
    <li
      className={cx(
        "group relative flex  font-poppins text-2xs font-semibold leading-none tracking-tightest text-gray-850",
        { "pr-[0.938rem]": position === "left" },
        { "pl-[0.938rem]": position === "right" }
      )}
      data-testid={`navigation-${label.toLowerCase()}`}
    >
      <Link
        role="link"
        to={`${link}?ref=header`}
        className={cx("flex items-center", navItemStyle)}
        reloadDocument
      >
        {label}
      </Link>
    </li>
  );
}
